import { render, staticRenderFns } from "./JobList.vue?vue&type=template&id=c32295d6&scoped=true&"
import script from "./JobList.vue?vue&type=script&lang=js&"
export * from "./JobList.vue?vue&type=script&lang=js&"
import style0 from "./JobList.vue?vue&type=style&index=0&id=c32295d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32295d6",
  null
  
)

export default component.exports